import { formatRisk } from "@/features/risks/entities/risk/model/risk.formatter"

// Toutes les clés possibles dans formatted
type RiskFormatted = ReturnType<typeof formatRisk>

// Items simples
export type SimpleMetricKey = "frequency" | "severity" | "prevention"
type SimpleMetric = {
  id: "f" | "g" | "p"
  name: string
  valueKey: SimpleMetricKey
  descriptions: string[]
}

// Items calculés
type DerivedMetric = {
  id: "rb" | "rr"
  name: string
  valueKey: keyof Pick<RiskFormatted, "valueInitialLabel" | "valueEffectiveLabel">
  colorKey: keyof Pick<RiskFormatted, "valueInitialColor" | "valueEffectiveColor">
  descriptions: string[]
}

export type RiskHelpItem = SimpleMetric | DerivedMetric

export const RISK_HELP_ITEMS: RiskHelpItem[] = [
  {
    id: "f",
    valueKey: "frequency",
    name: "risk_item_f",
    descriptions: ["risk_item_f_desc_1", "risk_item_f_desc_2"]
  },
  {
    id: "g",
    valueKey: "severity",
    name: "risk_item_g",
    descriptions: ["risk_item_g_desc_1", "risk_item_g_desc_2"]
  },
  {
    id: "p",
    valueKey: "prevention",
    name: "risk_item_p",
    descriptions: ["risk_item_p_desc_1", "risk_item_p_desc_2"]
  },
  {
    id: "rb",
    valueKey: "valueInitialLabel",
    colorKey: "valueInitialColor",
    name: "risk_item_rb",
    descriptions: ["risk_item_rb_desc_1", "risk_item_rb_desc_2", "risk_item_rb_desc_3"]
  },
  {
    id: "rr",
    valueKey: "valueEffectiveLabel",
    colorKey: "valueEffectiveColor",
    name: "risk_item_rr",
    descriptions: ["risk_item_rr_desc_1", "risk_item_rr_desc_2", "risk_item_rr_desc_3"]
  }
] as const

export type HelpKey = (typeof RISK_HELP_ITEMS)[number]["id"]
